import { db } from "./firebase";
import firebase from "firebase/app";
import "firebase/firestore";

export const resetPlayerForSlate = (userID, playerID, slateGameID) => {
  db.collection("lockedPlayers")
    .where("userID", "==", userID)
    .where("slateGameID", "==", slateGameID)
    .where("playerID", "==", playerID)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        doc.ref.delete();
        console.log("Firestore LFD", doc.id, doc.data());
      });
    })
    .catch((error) => {
      console.log("Firestore LFD", error.message);
    });
};

export const getLockedPlayerForSlate = (userID, slateGameID) => {
  console.log("userID: ", userID, "slateGameID", slateGameID);
  return db
    .collection("lockedPlayers")
    .where("userID", "==", userID)
    .where("slateGameID", "==", slateGameID)
    .get();
};

export const getExcludedPlayerForSlate = (userID, slateGameID) => {
  return db
    .collection("excludedPlayers")
    .where("userID", "==", userID)
    .where("slateGameID", "==", slateGameID)
    .get();
};

export const deleteDocument = (document) => {
  document.ref.delete();
};

export const addDataToExcludedCollection = (data) => {
  db.collection("excludedPlayers")
    .add(data)
    .then((docRef) => {
      console.log("Document written with ID: ", docRef.id);
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
};

export const addDataToLockedCollection = (data) => {
  db.collection("lockedPlayers")
    .add(data)
    .then((docRef) => {
      console.log("Document written with ID: ", docRef.id);
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
};

export const addDataToLineupCollection = (data) => {
  db.collection("lineups")
    .add(data)
    .then((docRef) => {
      console.log("Document written with ID: ", docRef.id);
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
};

export const getOneOfSameLineupsForSlateForUser = (
  slateID,
  lineupIdentifier,
  userID
) => {
  return db
    .collection("lineups")
    .where("userID", "==", userID)
    .where("slateID", "==", slateID)
    .where("lineupIdentifier", "==", lineupIdentifier)
    .orderBy("createdAt", "desc")
    .limit(1)
    .get();
};
export const getLineupsForSlateForUser = (slateID, userID) => {
  return db
    .collection("lineups")
    .where("userID", "==", userID)
    .where("slateID", "==", slateID)
    .orderBy("createdAt", "desc")
    .get();
};

export const isEmailInUserGroup = (email) => {
  alert("email: " + email);
  return db
    .collection("userGroups")
    .where("email", "==", email)
    .get();
};

export const getUserMetaData = async (email) => {
  const data = await db.collection("userMetaData")
    .where("email", "==", email)
    .get();
  return data
}

export const insertUserMetaData = (data) => {
  db.collection("userMetaData").add(data).then((docRef) => {
    console.log("Document written with ID: ", docRef.id);
    return true
  })
    .catch((error) => {
      console.error("Error adding User Metadata document: ", error);
      return false
    });
}

export const getTourStateFromUserMetaData = async (email) => {
  const data = await db.collection("userMetaData")
    .where("email", "==", email)
    .get();
  // check if data is empty
  if (data.empty) {
    return null // should not happen
  } else {
    return data.docs[0].data().preferences.web.isFirstTimeUserGuideVisible
  }
}

export const updateTourStateInUserMetaData = async (email, state) => {
  const data = await db.collection("userMetaData")
    .where("email", "==", email)
    .get();
  const docId = data.docs[0].id;
  db.collection("userMetaData").doc(docId).update({
    "preferences.web.isFirstTimeUserGuideVisible": state
  })
}

export const insertNotificationTokenInTokensListUserMetaData = async (email, token) => {
  const data = await db.collection("userMetaData")
    .where("email", "==", email)
    .get();
  console.log("data: ", data.docs[0].data())
  const docId = data.docs[0].id;
  // "preferences.web.notificationTokens" is an array
  db.collection("userMetaData").doc(docId).update({
    "preferences.web.notificationTokens": firebase.firestore.FieldValue.arrayUnion(token)
  })
}